import script from "./ExamErrorState.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamErrorState.vue?vue&type=script&setup=true&lang=js"

import "./ExamErrorState.vue?vue&type=style&index=0&id=758b699c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-758b699c"]])

export default __exports__